import {
    createComponents,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import {
    createRelatedLinks,
    RELATED_LINKS_BASE_CLASSNAME,
} from '@vfde-brix/ws10/related-links';

const SELECTOR_RELATED_LINKS = `.${RELATED_LINKS_BASE_CLASSNAME}`;

/**
 * Mounts WS10 Related Links component.
 * Note: Have to mount to set the correct column widths
 */
export const mountRelatedLinks = () =>
    createComponents(SELECTOR_RELATED_LINKS, createRelatedLinks, NO_PATTERN_BUSINESS_LOGIC);
